import api from './authService';

const handleError = (error) => {
  if (error.response) {
    const { data } = error.response;
    return {
      message: data.message || 'An error occurred',
      errors: data.errors || {},
      status: error.response.status,
    };
  }
  if (error.request) {
    return { message: 'Network error. Please check your connection.', status: 0 };
  }
  return { message: error.message || 'An error occurred', status: 0 };
};

const chatPath = (bookingId, isAdmin) =>
  isAdmin ? `/admin/bookings/${bookingId}/chat/messages` : `/bookings/${bookingId}/chat/messages`;

const chatUnreadPath = (bookingId, isAdmin) =>
  isAdmin ? `/admin/bookings/${bookingId}/chat/unread-count` : `/bookings/${bookingId}/chat/unread-count`;

const chatReadPath = (bookingId, isAdmin) =>
  isAdmin ? `/admin/bookings/${bookingId}/chat/read` : `/bookings/${bookingId}/chat/read`;

export const fetchBookingChatMessages = async (bookingId, { since, limit } = {}, isAdmin = false) => {
  try {
    const response = await api.get(chatPath(bookingId, isAdmin), {
      params: { ...(since ? { since } : {}), ...(limit ? { limit } : {}) },
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const sendBookingChatMessage = async (bookingId, { body, client_msg_id: clientMsgId }, isAdmin = false) => {
  try {
    const response = await api.post(chatPath(bookingId, isAdmin), {
      body,
      ...(clientMsgId ? { client_msg_id: clientMsgId } : {}),
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const fetchBookingChatUnreadCount = async (bookingId, isAdmin = false) => {
  try {
    const response = await api.get(chatUnreadPath(bookingId, isAdmin));
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const markBookingChatRead = async (bookingId, isAdmin = false) => {
  try {
    const response = await api.post(chatReadPath(bookingId, isAdmin));
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const bookingChatUnreadQueryKey = (bookingId, isAdmin = false) => ['bookingChatUnread', bookingId, isAdmin];
